var render = function render(){var _vm=this,_c=_vm._self._c;return _c('listbox-input',{attrs:{"label":_vm.label,"name":_vm.name,"items":_vm.options,"disabled":_vm.disabled,"placement":_vm.placement,"fluid-width":""},on:{"select":_vm.onSelect},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }